<template>
  <div style='padding-left:5px;padding-right:35px;'>
    <div class='col-12' v-html="content"></div>
    <div class='col-12 col-sm'>
      <div class='form-row'>
        <fieldset role="group" class='form-group' style='margin-top:0px;'>
          <legend id='lbl_cn1' class='radioLegend' style='font-weight: 600; color: #333;'>{{$t('text.page9_input1')}}</legend>
          <div class='col' style='padding-top:15px;padding-left:00px;padding-right:0px;'>
              <span class='radio'>
                  <input v-model="confirmNotice" name='confirmNotice' id='cn1y' type='radio' value='true' aria-required="true" aria-labelledby='lbl_confirmNotice_yes' aria-describedby='err_confirmNotice'/>
                  <label id='lbl_confirmNotice_yes' for='cn1y' class='radio-label'>{{$t('text.yes')}}</label>
              </span>
              <span class='radio'>
                  <input v-model="confirmNotice" name='confirmNotice' id='cn1n' type='radio' value='false' aria-labelledby='lbl_confirmNotice_no' aria-describedby='err_confirmNotice'/>
                  <label id='lbl_confirmNotice_no' for='cn1n' class='radio-label'>{{$t('text.no')}}</label>
              </span>
          </div>
        </fieldset>
      </div>
      <div class='form-row'>
        <span id='err_confirmNotice' for='cn1y' class='feedback' tabindex='-1'></span>
      </div>
    </div>
    <br/>
    <div class='col-12'>
      <span v-if='this.$store.state.site==="cibc"'>{{$t('text.page9_returnpolicy')}}</span>
      <span v-else>{{$t('text.page9_returnpolicynm')}}</span>
    </div>
    <div  class='form-row checkboxContainer is-valid' style='background-color: #FFFFFF; margin-top:40px;padding:20px;padding-left:5px; padding-top:25px;'>
      <div class='col-auto text-center'>
        <b style='padding-left:15px; padding-right:15px;'></b>
        <input v-model="confirmPrivacyPolicy" class='regular-checkbox' type='checkbox' id='confirmPrivacyPolicy' name="confirmPrivacyPolicy" :aria-checked='confirmPrivacyPolicy' role='checkbox' aria-required="true" >
      </div>
      <div class='col'>
        <label for='confirmPrivacyPolicy' class='checkbox-label'>
          <p>
            {{$t('text.page9_confirmA')}}
            <a href='javascript:void(0)' @click='OpenInNewWindow(url2)'>{{$t('text.page9_confirmB')}}</a>
            {{$t('text.page9_confirmC')}}
          </p>
        </label>
      </div>
    </div>
    <div class='form-row'>
        <span id='err_confirmPrivacyPolicy' for='confirmPrivacyPolicy' class='feedback' tabindex='-1'></span>
    </div>
    <div class='form-row checkboxContainer is-valid' style='background-color: #FFFFFF; margin-top:40px;padding:20px;padding-left:5px; padding-top:25px;'>
      <div class='col-auto text-center'>
        <b style='padding-left:15px; padding-right:15px;'></b>
        <input v-model="confirmWhatsNotCovered" class='regular-checkbox' type='checkbox' id='confirmWhatsNotCovered' name="confirmWhatsNotCovered" :aria-checked='confirmWhatsNotCovered' role='checkbox' aria-required="true" >
      </div>
      <div class='col'>
        <label for='confirmWhatsNotCovered' class='checkbox-label'>
          <p>
            {{$t('text.page9_confirmF')}}
            <a href='javascript:void(0)' @click='OpenInNewWindow(url3)'>{{$t('text.page9_confirmG')}}</a>
            {{$t('text.page9_confirmH')}}
            <a href='javascript:void(0)' @click='OpenInNewWindow(url1)'>{{$t('text.page9_confirmI')}}</a>
            {{$t('text.page9_confirmJ')}}
          </p>
        </label>
      </div>
    </div>
    <div class='form-row'>
        <span id='err_confirmWhatsNotCovered' for='confirmWhatsNotCovered' class='feedback' tabindex='-1'></span>
    </div>
  </div>
</template>

<script>
import { initKeywords, addKeywords } from "../utils/keywords.js";
import { addNavProceedCheck } from "../utils/navProceed.js";
import { validationRules } from "../utils/validation_rules.js";
import { validateField } from "../utils/validation.js";
import getLocale from "../utils/getLocale";

export default {
  computed: {
    confirmNotice: {
      get() {
        return this.$store.state.confirmNotice;
      },
      set() {
        validateField(document.getElementById("cn1y"), true, validationRules());
      }
    },
    confirmWhatsNotCovered: {
      get() {
        return this.$store.state.confirmWhatsNotCovered;
      },
      set() {
        validateField(document.getElementById("confirmWhatsNotCovered"), true, validationRules());
      }
    },
    confirmPrivacyPolicy: {
      get() {
        return this.$store.state.confirmPrivacyPolicy;
      },
      set() {
        validateField(document.getElementById("confirmPrivacyPolicy"), true, validationRules());
      }
    },
    content: {
      get(){
        let contentText = " " + addKeywords(this.$store.state.product.Insured[0].Insured.PreExs[0].Description) + "</p>";
        if(this.$store.state.site==="cibc"){
          contentText = this.$t("text.page9_content") + contentText;
        }
        else {
          contentText = this.$t("text.page9_contentnm") + contentText;
        }
        return contentText;
      }
    },
    url1() {
      // Certificate link
      let clientCode;
      if(this.$store.state.site==="cibc") {
        clientCode="CIBC"
      } else {
        clientCode="CIBCIndividual";
      }
      return (
        window.location.origin + 
        "/" + 
        getLocale(true) +
        "/api/certificate/" +
        clientCode +
        "/" +
        this.$store.state.product.Product.ProductCode
      );
    },
    url2() {
      // Privacy link
      let pathInsert="";
      const pathArray=window.location.pathname.split("/");
      if(pathArray[1]==="cibc"||pathArray[2]==="cibc"||pathArray[1]==="cibcinsurance"||pathArray[2]==="cibcinsurance"){ pathInsert="/cibc"}
      return (
          window.location.origin +
          pathInsert + 
          "/assets/documents/" +
          this.$t("text.link_privacy")
      );
    },
    url3() {
      // Exceptions link
      let pathInsert="";
      const pathArray=window.location.pathname.split("/");
      if(pathArray[1]==="cibc"||pathArray[2]==="cibc"||pathArray[1]==="cibcinsurance"||pathArray[2]==="cibcinsurance"){ pathInsert="/cibc"}
      return (
        window.location.origin +
        pathInsert + 
        "/assets/documents/exceptions/" + this.$store.state.product.Product.ProductCode + "Exceptions_" + this.$i18n.locale + ".pdf"
      );
    }
  },
  methods: {
    OpenInNewWindow(url, width, height) {
      const popupWidth = width == null ? 1000 : width;
      const popupHeight = height == null ? 900 : height;
      window.open(
        url,
        "popup",
        "scrollbars=1,resizable=1,width=" +
          popupWidth +
          ",height=" +
          popupHeight
      );
    },
  },
  mounted() {
    // Clear appended text from Quote page title;
    document.getElementById("stepTitleAppend").innerHTML="";

    // If this session already has a policy number, reset the session
    if(this.$store.state.policyNumber!==""){location.reload();}

    // Focus stepTitle for accessibility.
    this.$nextTick( () => {
      document.getElementById("stepTitle").focus();
    });
    
    initKeywords(this);

    // Check if Next button should be enabled or disabled.
    const targets = [
      document.getElementById("cn1y")
    ];
    this.$nextTick( () => {
      addNavProceedCheck(targets);
      // Add keywords to Pre-Ex
    });

    // Link Coverage Details button to selected product.
    document.getElementById("btnCoverageDetails").setAttribute("data-product",this.$store.state.product.Product.ProductCode);
    document.getElementById("btnCoverageDetails2").setAttribute("data-product",this.$store.state.product.Product.ProductCode);
  },
};
</script>

<style scoped>

.checkboxContainer.is-valid {
  border: 1px solid #ccc; 
}

</style>
